interface MatcherLocation {
  postal_code: string;
  longitude: number;
  latitude: number;
  city: string;
  region: string;
  region_code: string;
  region_name: string;
  country: string;
  distance: number;
}

const LOCATION_GATEWAY_BASE_URL =
  'https://api.drtlgi.com/location-gateway/postal-codes';

export async function getMatcherLocationsFromZip(
  zipCode: string
): Promise<MatcherLocation[]> {
  const url = `${LOCATION_GATEWAY_BASE_URL}?${new URLSearchParams({
    postal_codes: zipCode
  })}`;

  const response = await fetch(url, {
    method: 'GET',
    keepalive: true
  });

  return response.json();
}
